import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_icon = _resolveComponent("base-icon")
  const _component_base_button = _resolveComponent("base-button")
  const _component_tooltip = _resolveComponent("tooltip")

  return ($props.isUnpublish)
    ? (_openBlock(), _createBlock(_component_tooltip, {
        key: 0,
        text: "This blog post is not visible to any user because it hasn't been published."
      }, {
        default: _withCtx(() => [
          _createVNode(_component_base_button, {
            theme: "accent",
            shape: "circle",
            enabled: false
          }, {
            default: _withCtx(() => [
              _createVNode(_component_base_icon, { name: "exclamation-triangle" })
            ]),
            _: 1 /* STABLE */
          })
        ]),
        _: 1 /* STABLE */
      }))
    : _createCommentVNode("v-if", true)
}